module.exports = __webpack_public_path__ + "static/media/insta_button_icon.c87d1fce.svg";